import { bool, string, func, object } from "prop-types";

const propTypes = {
  includeSearchBar: bool.isRequired,
  searchPlaceholder: string.isRequired,
  searchRef: object.isRequired,
  handleKeyDown: func.isRequired,
  searchTerm: string.isRequired,
  setSearchTerm: func.isRequired,
  searchIcon: object.isRequired,
  clearAllFacets: func.isRequired,
};

export const SearchBar = (props) => {
  const {
    includeSearchBar,
    searchPlaceholder,
    searchRef,
    handleKeyDown,
    searchTerm,
    setSearchTerm,
    searchIcon,
    clearAllFacets,
  } = props;

  return (
    includeSearchBar && (
      <div className="faculty-directory-listing__search">
        <input
          className="faculty-directory-listing__search-input"
          placeholder={searchPlaceholder}
          ref={searchRef}
          onKeyDown={handleKeyDown}
          defaultValue={searchTerm}
        ></input>
        <button
          aria-label="Search"
          onClick={(event) => {
            event.preventDefault();
            searchRef.current.value !== searchTerm
              ? [clearAllFacets(), setSearchTerm(searchRef.current.value)]
              : null;
          }}
          className="faculty-directory-listing__search-btn"
        >
          {searchIcon}
        </button>
      </div>
    )
  );
};

SearchBar.propTypes = propTypes;
